export default 'counterRealtime'
